import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SendIcon from '@mui/icons-material/Send';
import { TextField } from '@shape-ds/components';
import { UseMutationResult } from '@tanstack/react-query';

export const RecordsInput = ({
  handleSubmit,
}: {
  handleSubmit: (payload: string) => Promise<UseMutationResult>;
}) => {
  const { t } = useTranslation();
  const commentRef = useRef<HTMLInputElement>(null);
  const [isValid, setIsValid] = useState<boolean>(!!commentRef.current?.value);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 3) {
      setIsValid(true);
    }
    if (commentRef.current) {
      commentRef.current.value = e.target.value;
    }
  };

  const onClickSendIcon = async () => {
    if (commentRef.current?.value && isValid) {
      const { data } = await handleSubmit(commentRef.current.value);

      if (data) {
        commentRef.current.value = '';
        commentRef.current.focus();
        setIsValid(false);
      }
    }
  };

  return (
    <TextField
      data-testid="comment-input"
      className={`comment ${isValid ? 'valid' : ''}`}
      iconPosition="end"
      inputRef={commentRef}
      fullWidth
      onChange={handleChange}
      icon={<SendIcon data-testid="send-icon" />}
      onClickIcon={onClickSendIcon}
      placeholder={t('records:add_a_comment')}
    />
  );
};
